'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withStyles = require('../with-styles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonGroup = function ButtonGroup(_ref) {
  var children = _ref.children,
      classNames = _ref.classNames;
  return _react2.default.createElement(
    'div',
    { className: 'c11n-button-group ' + classNames.root },
    children
  );
};

ButtonGroup.propTypes = {
  /**
   * The buttons to appear within the group
   */
  children: _propTypes2.default.any,

  /**
   * The spacing to be applied
   */
  spacing: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.number]),

  /**
   * The alignment of the buttons in the group
   */
  align: _propTypes2.default.oneOf(['left', 'center', 'right']),

  /**
   * Custom styles to be applied to the button
   */
  styles: _propTypes2.default.object
};

ButtonGroup.defaultProps = {
  spacing: 0.25,
  styles: {}
};

exports.default = (0, _withStyles2.default)(_styles2.default)(ButtonGroup);


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/button-group/index.js
// module id = 66
// module chunks = 0